<template>
    <v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="My Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="mt-4">
            <v-img :src="require('@/assets/banners/jobs-by-category.png')"></v-img>
        </div>
        
        <div class="display-1 text-center bMapCareer--text font-weight-medium mt-8">PROFESSION OF THE FUTURE</div>
        <!-- <div class="display-1 text-center bMapCareer--text font-weight-medium mt-8 d-flex justify-center align-center" v-if="loaded">
            <div class="mr-2">JOBS BY CATEGORY</div>
        </div> -->

        <div class="text-center">
            <v-btn text class="accent--text" @click="$router.push('/map-of-careers/jobs-by-category/professions-of-future')">
                <v-icon small color="accent" left>fa-angle-left</v-icon>
                Back to professions of the future
            </v-btn>
        </div> 

        <v-divider class="mt-3 mb-6"></v-divider>

        <v-card outlined v-if="loaded">
            <div class="pa-6 primary">
                <div class="display-1 white--text">{{item.name}} <span class="title font-weight-regular" v-if="item.info.length>1">({{item.info.length}} colleges)</span> </div>
            </div>
            <div class="pa-6 pb-12">
                <div  v-for="(fac, index) in item.info" :key="fac.id">
                    <div class="body-2 font-weight-bold primary--text text--darken-1">COLLEGE</div>
                    <v-chip class="font-weight-medium ml-n2" v-html="fac.college"></v-chip>
                    <!-- <div v-html="fac.college"></div> -->

                    <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">LOCATION</div>
                    <div v-html="fac.location"></div>

                    <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">ACADEMIC PROGRAM</div>
                    <div v-html="fac.academicProgram"></div>

                    <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">ANNUAL COST OF ATTENDANCE</div>
                    <div v-if="fac.annualCost>0">${{formatAmount(fac.annualCost)}}</div>
                    <div v-else>{{fac.annualCost}}</div>

                    <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">DESCRIPTION</div>
                    <div v-html="fac.description"></div>

                    <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">OVERVIEW</div>
                    <div v-html="fac.overview"></div>

                    <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">HOW TO APPLY</div>
                    <a v-html="fac.howTo" target="_blank" :href="fac.howTo" class="accent--text"></a>

                    <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6" v-if="fac.day">A DAY IN THE LIFE OF THIS PROFESSION</div>
                    <a v-html="fac.day" target="_blank" :href="fac.day" class="accent--text" v-if="fac.day"></a>

                    <v-divider class="my-10" v-if="index<item.info.length-1"></v-divider>
                </div>
            </div>
        </v-card>

        <SendingLoader v-else />
    </v-card>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Careers from '@/firebase/careers'

export default {
    data: () => ({
        loaded: false,
        items: null
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Careers.getPOF(this.$route.params.id)
                    .then(response => {
                        if (response.status == true) {
                            this.item = response.doc.data();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>

<style>
    b {
        font-size:14px;
    }
</style>